/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ResetPasswordDto {
  email: string;
}

export interface ListInventoryItemsParameters {
  limit?: number;
  sort?: "status" | "skuCode" | "skuName" | "usageCount" | "usageSeconds" | Record<string, "asc" | "desc">;
  select?: ("status" | "skuCode" | "skuName" | "usageCount" | "usageSeconds")[];
  startAfter?: string;
  endBefore?: string;
  status?: "IN_USE" | "OUT_OF_USE" | "LOST" | "SOLD";
  skuCode?: string;
  skuName?: string;
  usageCount?: number;
  usageSeconds?: number;
}

export interface PagedInventoryItemsDTO {
  data: (
    | {
        id: string;
        skuId: string | null;
        skuName: string | null;
        skuCode: string | null;
        shopId: string;
        barCode?: string;
        usageCount: number;
        usageSeconds: number;
        lastUsed: string | null;
        createdAt: string;
        fieldValues?: Record<string, number>;
        locationId: string;
        identifiers: string[];
        fixedFieldValues?: { soleLength?: string; dinVariation?: string };
        activeOrderIds?: string[];
        reservedCountsByOrderId?: Record<string, number>;
        type: "single";
        status: "IN_USE" | "OUT_OF_USE" | "LOST" | "SOLD";
        allocation: { rental?: boolean; sales?: boolean };
      }
    | {
        id: string;
        skuId: string | null;
        skuName: string | null;
        skuCode: string | null;
        shopId: string;
        barCode?: string;
        usageCount: number;
        usageSeconds: number;
        lastUsed: string | null;
        createdAt: string;
        fieldValues?: Record<string, number>;
        locationId: string;
        identifiers: string[];
        fixedFieldValues?: { soleLength?: string; dinVariation?: string };
        activeOrderIds?: string[];
        reservedCountsByOrderId?: Record<string, number>;
        type: "bulk";
        statuses: Record<string, number>;
        quantity: number;
        allocations: { rental?: number; sales?: number };
      }
  )[];
  count: number;
  nextPageToken?: string;
  prevPageToken?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected toQueryString(input?: QueryParamsType): string {
    const qs = new URLSearchParams();
    const addQueryParameters = (qs: URLSearchParams, input: QueryParamsType, level = 0, prefix = "") => {
      const tokey = (key: string) => {
        return level === 0 ? `${prefix}${key}` : `${prefix}[${key}]`;
      };
      for (const [key, value] of Object.entries(input)) {
        switch (typeof value) {
          case "string":
          case "number":
          case "boolean":
            qs.append(tokey(key), value.toString());
            break;
          case "object":
            if (value === null) {
              qs.append(tokey(key), "null");
            } else if (Array.isArray(value)) {
              for (const item of value as Array<any>) {
                qs.append(tokey(key) + "[]", item.toString());
              }
            } else {
              addQueryParameters(qs, value, level + 1, tokey(key));
            }
            break;
          default:
            continue;
        }
      }
    };
    addQueryParameters(qs, input || {});
    return qs.toString();
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data.data;
    });
  };
}

/**
 * @title Rentle API
 * @version 2
 * @contact
 *
 * API documentation for Rentle API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name RootGetRootMessage
   * @request GET:/
   */
  rootGetRootMessage = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: "GET",
      ...params,
    });

  v1 = {
    /**
     * No description
     *
     * @name RootGetRootMessage
     * @request GET:/v1
     */
    rootGetRootMessage: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v1`,
        method: "GET",
        ...params,
      }),
  };
  v2 = {
    /**
     * No description
     *
     * @name RootGetRootMessage
     * @request GET:/v2
     */
    rootGetRootMessage: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v2`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags users, v2
     * @name UsersResetPassword
     * @request POST:/v2/users/reset-password
     */
    usersResetPassword: (data: ResetPasswordDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/v2/users/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inventory-items
     * @name InventoryItemsList
     * @request GET:/v2/inventory-items
     */
    inventoryItemsList: (
      query?: {
        limit?: number;
        sort?: "status" | "skuCode" | "skuName" | "usageCount" | "usageSeconds" | Record<string, "asc" | "desc">;
        select?: ("status" | "skuCode" | "skuName" | "usageCount" | "usageSeconds")[];
        startAfter?: string;
        endBefore?: string;
        status?: "IN_USE" | "OUT_OF_USE" | "LOST" | "SOLD";
        skuCode?: string;
        skuName?: string;
        usageCount?: number;
        usageSeconds?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagedInventoryItemsDTO, any>({
        path: `/v2/inventory-items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
